import clsx from "clsx";
import Plus from "../../src/assets/svg/plus.svg";
import Minus from "../../src/assets/svg/minus.svg";

export interface ButtonExpandContentProps {
  title: string;
  onClick: () => void;
  onClickWhole?: Boolean;
  open: Boolean;
  className?: string;
  textSize?: string;
  fontWeight?: string;
  children?: React.ReactNode;
}

export function ButtonExpandContent(props: ButtonExpandContentProps) {
  const {
    title,
    onClick,
    onClickWhole = true,
    open,
    className,
    textSize = "text-base sm:text-lg",
    fontWeight = "Font-medium",
    children,
  } = props;

  return (
    <div
      onClick={onClickWhole ? onClick : undefined}
      className={clsx(
        "flex justify-between gap-4",
        onClickWhole && "cursor-pointer"
      )}
    >
      <div
        onClick={onClickWhole ? undefined : onClick}
        className="flex items-center gap-3 cursor-pointer"
      >
        <img src={open ? Minus : Plus} alt={open ? "Minus" : "Plus"} />
        <h4
          className={clsx(
            "text-gray-extra-dark",
            className,
            textSize,
            fontWeight
          )}
        >
          {title}
        </h4>
      </div>
      {children}
    </div>
  );
}

export default ButtonExpandContent;
